<template>
    <div class="pc">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'pc',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.pc {
}
</style>
